import React from 'react';
import { css } from '@compiled/react';
import DOMPurify from 'dompurify';

interface EmbeddedIframeContentProps {
  iframe?: string | null;
}

export const EmbeddedIframeContent: React.FC<EmbeddedIframeContentProps> = ({ iframe }) => {
  if (!iframe) {
    return null;
  }

  return (
    <div css={iframeContainerStyles}>
      <div
        css={iframeStyles}
        data-testid="embedded-iframe-section"
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(iframe, {
            ADD_TAGS: ['iframe', 'script'],
            ADD_ATTR: ['src', 'frameborder', 'allowfullscreen', 'allow', 'style', 'title'],
            FORBID_TAGS: ['div'],
            FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover'],
            ALLOW_DATA_ATTR: true,
            ALLOW_ARIA_ATTR: true,
          }),
        }}
      />
    </div>
  );
};

const iframeContainerStyles = css({
  width: '100%',
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'center',
  marginTop: '24px',
  marginBottom: '24px',
});

const iframeStyles = css({
  position: 'relative',
  width: 'min(92%, 1080px)',
  aspectRatio: '16 / 9',
  minHeight: '360px',
  backgroundColor: 'transparent',

  iframe: {
    position: 'absolute !important',
    inset: 0,
    width: '100% !important',
    height: '100% !important',
    maxWidth: '100% !important',
    maxHeight: '100% !important',
  },
});

